module.exports = __webpack_public_path__ + "static/media/nav-scanline-left.200cffa5.svg";